import {Component, Injector, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {BaseComponent} from '../../../base.component';
import {FeaturesOptions} from './options/features.options';
import {RequestType} from '../../../../enums/request.type';
import {DataResponse} from '../../../../network/service/data.response';
import {SnackBarUtil} from '../../../../util/snack.bar.util';

@Component({
  selector: 'app-features-dialog',
  standalone: false,
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.scss']
})
export class FeaturesDialogComponent extends BaseComponent implements OnInit {
  displayedColumns: string[] = ['additive', 'feature', 'price', 'maxCapacity', 'actions'];
  dataSource: any[] = [];
  editingFeature: any = null;
  featuresOptions = new FeaturesOptions();
  isAddingNew = false;

  constructor(injector: Injector, private readonly matDialogRef: MatDialogRef<FeaturesDialogComponent>) {
    super(injector);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.loadFeatures();
  }

  loadFeatures(): void {
    this.serviceApi.getServicePriceAdditives(0, 0, 'Additive,Attribute,Business', RequestType.ALL, this.featuresOptions.branchId, {
      Filter: {
        Values: [{
          Field: 'ServicePriceId',
          Type: 'EQ',
          Value: this.featuresOptions.servicePriceId
        }]
      }
    }).subscribe((res: DataResponse<any>) => {
      if (res.success) {
        this.dataSource = res.data.map((item: any) => ({
          id: item.ServicePriceAdditiveId,
          additive: item.AdditiveId, // Store ID for select
          additiveTitle: item.Additive?.Title || '',
          feature: item.AttributeId, // Store ID for select
          featureTitle: item.Attribute?.AttributeTitle || '',
          price: item.Price || 0,
          maxCapacity: item.MaxCapacity || 0,
          business: item.BusinessId, // Store ID for select
          businessTitle: item.Business?.Title || '',
          isNew: false,
          isEditing: false,
          originalData: item
        }));
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  addNewFeature(): void {
    this.isAddingNew = true;
    this.editingFeature = null;
    const newRow = {
      id: null,
      additive: '', // AdditiveId
      additiveTitle: '',
      feature: '', // AttributeId
      featureTitle: '',
      price: 0,
      maxCapacity: 0,
      business: '', // BusinessId
      businessTitle: '',
      isNew: true,
      isEditing: true
    };
    this.dataSource = [newRow, ...this.dataSource];
  }

  editFeature(feature: any): void {
    this.cancelEditing();
    feature.isEditing = true;
    this.editingFeature = feature;
  }

  saveFeature(feature: any): void {
    if (feature.isNew) {
      // Create: Send only the 5 required fields
      const newData = {
        AdditiveId: feature.additive,
        AttributeId: feature.feature,
        ServicePriceId: this.featuresOptions.servicePriceId,
        Price: feature.price,
        MaxCapacity: feature.maxCapacity,
        BusinessId: this.featuresOptions.branchId
      };
      this.serviceApi.createServicePriceAdditives(newData).subscribe(
        (response: any) => {
          this.loadFeatures();
          this.cancelEditing();
        },
        (error: any) => {
        }
      );
    } else {
      // Update: Send only the 5 required fields
      const updateData = {
        AdditiveId: feature.additive,
        AttributeId: feature.feature,
        ServicePriceId: this.featuresOptions.servicePriceId,
        Price: feature.price,
        MaxCapacity: feature.maxCapacity,
        BusinessId: this.featuresOptions.branchId
      };
      this.serviceApi.updateServicePriceAdditives(feature.id, updateData).subscribe(
        (response: any) => {
          this.loadFeatures();
          this.cancelEditing();
        },
        (error: any) => {
        }
      );
    }
  }

  cancelEditing(): void {
    if (this.isAddingNew) {
      this.dataSource = this.dataSource.filter(item => !item.isNew);
      this.isAddingNew = false;
    }
    this.dataSource.forEach(item => {
      item.isEditing = false;
    });
    this.editingFeature = null;
  }

  deleteFeature(id: number): void {
    this.serviceApi.deleteServicePriceAdditives(id).subscribe(
      (response: any) => {
        this.loadFeatures();
      },
      (error: any) => {
      }
    );
  }

  isEditing(feature: any): boolean {
    return feature.isEditing;
  }

  onNoClick(): void {
    this.matDialogRef.close();
  }
}
